<template>
  <app-admin>
    <div class="container content">
      <div class="flex-between">
        <h1>Программы</h1>

        <div class="btn" @click="createTest">
          <font-awesome-icon icon="plus"/>
          Добавить новый тест
        </div>

      </div>
      <app-search @change="handleFilter" debounce="500"/>
      <div class="players">
        <table cellspacing="0" cellpadding="0" class="main-table">
          <thead>
          <tr>
            <th class="index">№</th>
            <th class="fio">Название программы</th>
            <th>Кол-во вопросов</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="filter.length != 0 && tests.length == 0">
            <td colspan="4" class="text-center"><em>По данному запросу ничего не найдено.</em></td>
          </tr>
          <tr v-for="(test, index) in tests" :key="test.id">
            <td>{{index+1}}</td>
            <td class="hover">
              <router-link :to="{ name: 'EditTest', params: { id: test.id }}">{{test.name}}</router-link>
            </td>
            <td>{{test.question_count}}</td>
            <td>
              <router-link :to="{ name: 'EditTest', params: { id: test.id }}">
                <font-awesome-icon icon="edit" v-tooltip="{content: 'Изменить вопросы', class: 'tooltip-custom'}"/>
              </router-link>
            </td>
          </tr>
          </tbody>
        </table>
        <pagination @change="setPage" :itemsPerPage="itemsPerPage" :resultCount="resultCount"/>

      </div>
      <transition name="fade">
        <NewTestModal @cancel="showModal=false" v-if="showModal"></NewTestModal>
      </transition>
    </div>
  </app-admin>
</template>

<script>
  import TestsService from '@/services/TestsService'
  import NewTestModal from '@/components/modal/NewTestModal'

  export default {
    name: 'tests',
    components: {
      NewTestModal
    },
    data () {
      return {
        filter: '',
        showModal: false,
        currentPage: 1,
        itemsPerPage: 10,
        resultCount: 0,
        tests: []
      }
    },
    computed: {},
    methods: {
      handleFilter: function (filter) {
        this.filter = filter
        this.getTests()
      },
      setPage (pageNumber) {
        this.currentPage = pageNumber
        this.getTests()
      },
      getTests () {
        TestsService.getTests(this.currentPage, this.itemsPerPage, this.filter).then(
          (response) => {
            this.tests = response.results
            this.resultCount = response.count
          }
        )
      },
      createTest () {
        this.showModal = true
      }
    },
    mounted () {
      this.getTests()
      this.$store.dispatch('setTest', '')
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/tests/Tests.vue